import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import router from "./router";
import { RouterProvider } from "react-router-dom";
import '@cloudscape-design/global-styles/index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { GlobalContextProvider } from './context';
import { Authenticator } from '@aws-amplify/ui-react';
import { I18nProvider } from '@cloudscape-design/components/i18n';
import messages from '@cloudscape-design/components/i18n/messages/all.all';
import "./pages/series/series.css";
import { createBrowserHistory } from 'history';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

if (root){
  const history = createBrowserHistory();
  const hash = history.location.hash
  if (hash) {
    const path = hash.replace(/^#/, '')
    if (path) {
      history.replace(path)
    }
  }
  root.render(
    <Authenticator.Provider>
      <GlobalContextProvider>
        <RouterProvider router={router} />
      </GlobalContextProvider>
    </Authenticator.Provider>
  );
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
